import { ImageStandard } from "../../../../modules/image/components/ImageStandard/ImageStandard";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = (props: IImageBlockProps) => {
  if (!props.image) {
    return null;
  }

  return <ImageStandard {...props} />;
};

ImageBlock.displayName = "Block::ImageBlock";
